export default {
  styleOverrides: {
    root: {
      padding: 'inherit',
      cursor: 'inherit'
    }
  }
}
